var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChanelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32547 9.40079L7.53063 8.83011H4.46962L3.67478 9.40079C3.4566 9.62191 3.61215 10 3.92001 10H8.08025C8.38857 10 8.54319 9.62144 8.32547 9.40079Z",
    fill: "#406EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7462 0H1.2539C0.607442 0 0.083252 0.530673 0.083252 1.18512V7.23826C0.083252 7.89271 0.607442 8.42338 1.2539 8.42338H10.7462C11.3926 8.42338 11.9168 7.89271 11.9168 7.23826V1.18512C11.9168 0.530673 11.3926 0 10.7462 0ZM5.45089 3.24019H4.77138V5.96352H3.88617V3.24019H3.20228V2.45284H5.45089V3.24019ZM7.63548 5.96352H6.72277L5.56529 2.45261H6.47338L7.17115 4.91434H7.18247L7.88486 2.45261H8.79757L7.63548 5.96352Z",
    fill: "#406EE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanelIcon);
export default __webpack_public_path__ + "static/media/chanel_icon.fdb1c3ed93e7a3cc9ed425ec9eeda4e5.svg";
export { ForwardRef as ReactComponent };